import QueryState from '../../components/query_state'
import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import preferredCycle from '../../helpers/preferred_cycle'

// Grab the airlines, redirect to an open cycle of the first airline when possible
// Perhaps in the future we can leverage local storage to return them to the last cycle they were viewing?
const LandingPage = () => {
  const { data: airlines, isLoading, error } = useQuery(['airlines'])
  const airline = airlines?.[0]
  const cycle = preferredCycle(airline?.cycles)

  return (
    <QueryState isLoading={isLoading} error={error} loadingClassName='h-screen w-screen'>
      <Navigate to={`/airlines/${airline?.id}/cycles/${cycle?.id}`} replace={true} />
    </QueryState>
  )
}

export default LandingPage
